@if (userPreferences$ | async; as userPreferences) {
  <ion-content>
    @if (userPreferences && userPreferences?.content && userPreferences?.content[0]; as preference) {
      <ion-row class="title-head">
        <ion-col size="10" class="ion-no-padding">
          <p class="status-title">{{ preference?._name[selectedLanguage] | translate }}</p>
        </ion-col>
        <ion-col size="2" class="ion-no-padding close-icon">
          <img (click)="goBack()" class="support-img" src="assets/images/close-circle.png" />
        </ion-col>
      </ion-row>
      <div class="preference-upper-wrapper">
        <p>
          {{
          preference?._des && preference?._des[selectedLanguage] ? preference?._des[selectedLanguage] : preference?.des
          }}
        </p>
      </div>
      <div class="preference-middle-wrapper">
        @if (preferencesReady) {
        <ion-item class="ion-no-padding">
          <ion-row>
            <ion-col size="9" class="text-content">
              <p>{{ "preference.SMS" | translate }}</p>
            </ion-col>
            <ion-col size="3" class="toggle-content">
              <ion-toggle mode="ios" name="sms" [checked]="preferences_settings.sms"
              (ionChange)="changePrefStatus($event.detail.checked, 'sms')"></ion-toggle>
            </ion-col>
          </ion-row>
        </ion-item>
        <ion-item class="ion-no-padding">
          <ion-row>
            <ion-col size="9" class="text-content">
              <p>{{ "preference.Receive" | translate }}</p>
            </ion-col>
            <ion-col size="3" class="toggle-content">
              <ion-toggle mode="ios" name="email"
              [checked]="preferences_settings.email" (ionChange)="changePrefStatus($event.detail.checked, 'email')"></ion-toggle>
            </ion-col>
          </ion-row>
        </ion-item>
        <ion-item class="ion-no-padding">
          <ion-row>
            <ion-col size="9" class="text-content">
              <p>{{ "preference.Push" | translate }}</p>
            </ion-col>
            <ion-col size="3" class="toggle-content">
              <ion-toggle mode="ios" name="push"
              [checked]="preferences_settings.push" (ionChange)="changePrefStatus($event.detail.checked, 'push')"></ion-toggle>
            </ion-col>
          </ion-row>
        </ion-item>
        }
      </div>
      @if (preference && preference._bottom_text && preference._bottom_text[selectedLanguage]) {
        <div class="preference-lower-wrapper" (click)="openPrefModal($event, userPreferences)"
          >
          <p [innerHTML]="preference._bottom_text[selectedLanguage] | safeHtml"></p>
        </div>
      }
    }
  </ion-content>
} @else {
  <app-in-progress-animation></app-in-progress-animation>
}

